export default __webpack_public_path__ + "static/media/logo.86b72fab.svg";